import {
  Card, CardContent, Typography, Button, Box, CircularProgress
} from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { useQuery } from '@tanstack/react-query';
import { useSession } from '../context/SessionContext';
import { feedbackApi } from '../utils/api';
import { FeedbackTeaser } from '../types';

export default function FeedbackTeaserPage() {
  const { session, updateStatus } = useSession();
  const courseLevel = session?.assessment_course_level?.trim() || 'Precalculus I';
  const { isLoading: loading } = useQuery<FeedbackTeaser>({
    queryKey: ['feedback', 'teaser'],
    queryFn: () => feedbackApi.getTeaser(),
  });

  const handleShowResults = async () => {
    await updateStatus('feedback');
  };

  if (loading) {
    return (
      <Card>
        <CardContent sx={{ p: 4, textAlign: 'center' }}>
          <CircularProgress sx={{ mb: 3 }} />
          <Typography variant="h6">Analyzing your responses...</Typography>
          <Typography variant="body2" color="text.secondary">
            This will only take a moment.
          </Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent sx={{ p: 4, textAlign: 'center' }}>
        <Box sx={{ mb: 3 }}>
          <AutoAwesomeIcon sx={{ fontSize: 60, color: 'primary.main' }} />
        </Box>

        <Typography variant="h4" component="h1" gutterBottom color="primary">
          Your Results Are Ready
        </Typography>


        <Box sx={{ maxWidth: 500, mx: 'auto' }}>
        <Typography variant="body1" paragraph>
          {`Thank you for completing the ${courseLevel} Readiness Check. Your responses provide a clear picture of your starting point.`}
        </Typography>

       <Typography variant="body1" paragraph>
          {`Based on your answers, we have prepared personalized feedback to help you understand your readiness for ${courseLevel} and decide how to move forward with confidence.`}
        </Typography>

        <Typography variant="body1" paragraph>
          There is no pass or fail. The goal of this assessment is understanding, not evaluation.
        </Typography>
        </Box>

        <Button
          variant="contained"
          size="large"
          onClick={handleShowResults}
          sx={{ mt: 2, px: 6 }}
        >
          View Your Feedback
        </Button>
      </CardContent>
    </Card>
  );
}
